function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var AUTH_FORM_SUBMITTING = 'auth/FORM_SUBMITTING';
export var AUTH_FORM_SUBMITTING_DONE = 'auth/FORM_SUBMITTING_DONE';
export var AUTH_FORM_ERROR_MESSAGE = 'auth/FORM_ERROR_MESSAGE';
export var AUTH_FORM_SUCCESS_MESSAGE = 'auth/FORM_SUCCESS_MESSAGE';
export var AUTH_FORM_ERROR_MESSAGE_RESET = 'auth/FORM_ERROR_MESSAGE_RESET';
export function authForms(state, action) {
  var type = action.type,
      payload = action.payload;

  if (!state) {
    var formNames = ['signup', 'setPassword', 'login', 'requestResetPassword'];
    state = {};
    formNames.forEach(function (formName) {
      state[formName] = {
        isSubmitting: false,
        errorMessage: {}
      };
    });
  }

  switch (type) {
    case AUTH_FORM_SUBMITTING:
      return Object.assign({}, state, _defineProperty({}, payload.form, Object.assign({}, state[payload.form], {
        isSubmitting: true,
        errorMessage: {} // also resetting the error messages here so we
        // don't have to fire another action every time

      })));

    case AUTH_FORM_SUBMITTING_DONE:
      return Object.assign({}, state, _defineProperty({}, payload.form, Object.assign({}, state[payload.form], {
        isSubmitting: false
      })));

    case AUTH_FORM_ERROR_MESSAGE:
      return Object.assign({}, state, _defineProperty({}, payload.form, Object.assign({}, state[payload.form], {
        errorMessage: payload.errorMessage,
        successMessage: undefined
      })));

    case AUTH_FORM_SUCCESS_MESSAGE:
      return Object.assign({}, state, _defineProperty({}, payload.form, Object.assign({}, state[payload.form], {
        successMessage: payload.successMessage,
        errorMessage: undefined
      })));

    case AUTH_FORM_ERROR_MESSAGE_RESET:
      return Object.assign({}, state, _defineProperty({}, payload.form, Object.assign({}, state[payload.form], {
        errorMessage: {}
      })));

    default:
      return state;
  }
}